// @flow

import _ from "lodash";
import React, { Component } from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Redirect } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";

import type { UserProfile } from "../types/user_profile";
import LoginRequired from "../lib/LoginRequired";
import SyncObjectApi from "../lib/sync_object_api";

type SyncObjectPartial = {
  object_name: string,
  class_name: string
};

type State = {
  inProgress: boolean,
  deleteObjectName: ?string,
  deleteInProgress: boolean,
  syncObjects: SyncObjectPartial[],
  error: ?Error,
  redirectTo: ?{
    editObjectName: string
  }
};

type Props = {
  setTitle: string => void,
  hideBackButton: () => void,
  user: UserProfile
};

class ListSyncObjectsView extends Component<Props, State> {
  state = {
    inProgress: true,
    deleteObjectName: null,
    deleteInProgress: false,
    syncObjects: [],
    error: null,
    redirectTo: null
  };

  loadObjectsList = async () => {
    this.setState({
      inProgress: true,
      syncObjects: []
    });
    const idToken = await this.props.user.getIdToken(true);
    const syncObjects = _.sortBy(await SyncObjectApi.list(idToken), obj => obj.class_name);

    this.setState({
      inProgress: false,
      syncObjects
    });
  };

  componentWillMount = async () => {
    this.props.setTitle("All sync objects");
    this.props.hideBackButton();
  };

  componentDidMount = async () => {
    await this.loadObjectsList();
  };

  handleClick = (syncObject: SyncObjectPartial) => {
    return () =>
      this.setState({
        redirectTo: {
          editObjectName: syncObject.object_name
        }
      });
  };

  markObjectForDelete = (objectName: string) => {
    return () => {
      this.setState({ deleteObjectName: objectName });
    };
  };

  renderListItem = (syncObject: SyncObjectPartial) => {
    return (
      <ListItem
        key={syncObject.object_name}
        button
        onClick={this.handleClick(syncObject)}
      >
        <ListItemText primary={syncObject.class_name} />
        <ListItemSecondaryAction>
          <IconButton
            aria-label="Delete"
            onClick={this.markObjectForDelete(syncObject.object_name)}
          >
            <DeleteIcon />
          </IconButton>
        </ListItemSecondaryAction>
      </ListItem>
    );
  };

  handleDeleteDialogClose = () => {
    this.setState({ deleteObjectName: null, deleteInProgress: false });
  };

  handleDeleteObject = async () => {
    this.setState({ deleteInProgress: true });
    const objectName = this.state.deleteObjectName;
    const idToken = await this.props.user.getIdToken(true);
    await SyncObjectApi.delete(objectName, idToken);
    this.handleDeleteDialogClose();
    this.loadObjectsList();
  };

  renderDeleteDialog = (classes: any) => {
    if (!this.state.deleteObjectName) {
      return null;
    }

    let dialogContent = null;
    if (this.state.deleteInProgress) {
      dialogContent = (
        <div>
          <CircularProgress className="progress-indicator" size={30} />
        </div>
      );
    }

    return (
      <Dialog
        open={!!this.state.deleteObjectName}
        onClose={this.handleDeleteDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Do you want to delete the object '{this.state.deleteObjectName}'?
        </DialogTitle>
        {dialogContent}
        <DialogActions>
          <Button
            onClick={this.handleDeleteDialogClose}
            disabled={this.state.deleteInProgress}
            color="primary"
          >
            No
          </Button>
          <Button
            onClick={this.handleDeleteObject}
            disabled={this.state.deleteInProgress}
            color="primary"
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  renderList = () => {
    return (
      <div>
        {this.renderDeleteDialog()}
        <List className="sync-objects-list" component="nav">
          {this.state.syncObjects.map(this.renderListItem)}
        </List>
      </div>
    );
  };

  render = () => {
    if (this.state.redirectTo) {
      return (
        <Redirect
          push
          to={`/objects/${this.state.redirectTo.editObjectName}`}
        />
      );
    } else if (this.state.inProgress) {
      return <CircularProgress className="progress-indicator" size={50} />;
    }

    return this.renderList();
  };
}

export default LoginRequired(ListSyncObjectsView);



// WEBPACK FOOTER //
// ./src/views/ListSyncObjectsView.js